<template>
    <div class="container--large-content">
        <template v-if="isPageReady">
            <div class="container">
                <h1
                    v-if="user != null"
                    class="daily-questions__title">{{ $t("chart-title", { x: capitalize(user.fname)}) }}</h1>
                <div class="chart-container">
                    <div class="cat-dropdown">
                        <div class="cat-dropdown-sub">
                            <div class="grid__item- desktop--3-">
                                <label
                                    class="sr-only field__label field--text__label"
                                    id="filter-theme-label"
                                    for="filter-theme">{{ $t("theme") }}</label>
                                <field-select
                                    id="filter-theme"
                                    input-label-id="filter-theme-label"
                                    :value="category"
                                    :options="categoryArray"
                                    @update-value="updateCategory" />
                            </div>
                        </div>
                        <div
                            class="cat-dropdown-sub"
                            style="margin-top: 10px;">
                            <div class="grid__item- desktop--3-">
                                <label
                                    class="sr-only field__label field--text__label"
                                    id="filter-theme-label"
                                    for="filter-theme">{{ $t("theme") }}</label>
                                <field-select
                                    id="filter-theme"
                                    input-label-id="filter-theme-label"
                                    :value="categoryType"
                                    :options="categoryTypeArray"
                                    @update-value="updateCategoryType" />
                            </div>
                        </div>
                        
                    </div>
                    <div class="chart-info">
                        <AstroChart
                            v-if="isPageReady"
                            :astro-data="astroData"
                        />
                    </div>
                    
                </div></div></template>
        <template v-else>
            <HorizontalBubbleLoader />
        </template>
    </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import axios from "axios";
import { userGroupInfo } from "@/utils/api/groupsApi.js";
import { getMe, getUserInfo } from "@/utils/api/usersApi.js";
import { getGroupTypeName, getGroupTypeColor } from "@/utils/helpers/group.js";
import HorizontalBubbleLoader from "@/components/loaders/HorizontalBubbleLoader.vue";
import AstroChart from "@/components/charts/AstroChart.vue";
import FieldSelect from "@/components/forms/FieldSelect.vue";



export default {
    name: "Chart",
    components: {
        "FieldSelect": FieldSelect,
        "AstroChart": AstroChart,
        "HorizontalBubbleLoader": HorizontalBubbleLoader
    },
    props: {
        partnerId: {
            type: String,
            required: false,
            default: null
        },
    },
    data() {
        return {
            user: null,
            isPageReady: false,
            currentGroupId: null,
            currentGroupType: 1,
            fetchInsightTraitsTentative: 0,
            isMobile: false,
            subTitles: null,
            userInspected: null,
            chartData: null,
            asData: {
                data:"",
                dataTransit: "",
                animateData: "",
            },          
            astroData : {},
            dataTransit: {},
            animateData: {},
            category: "whole_sign_house",
            categoryType: "birth",
            categoryArray: [
                {
                    "value": "whole_sign_house", "label": this.$t("whole_sign_house")
                },
                {
                    "value": "placidus", "label": this.$t("placidus")
                }
            ],
            categoryTypeArray: [
                {
                    "value": "birth", "label": this.$t("birth_chart")
                },
                {
                    "value": "birth_transition", "label": this.$t("birth_chart_transit")
                }
            ],
        };
    },
    computed: {
        // currentDataId
        // Current data (user of group) id to display
        currentDataId() {
            return this.$store.getters["globalModule/getCurrentDataId"];
        },
        // loggedUser
        // Current logged user
        loggedUser() {
            return this.$store.getters["userModule/getUser"];
        },
        // groups
        // User groups info
        groups() {
            return this.$store.getters["userModule/getGroups"];
        },
    },
    watch: {
        currentDataId: function() {
            this.user = null;
            this.fetchUserInfo();
            // this.getAstroData();
        },
    },
    created() {
        // User Groups
        this.fetchGroups();
        
    },
    methods: {
        // Fetch User Groups Info
        fetchGroups() {
            const user = {
                "id": this.loggedUser.id_person
            };

            userGroupInfo(user).then((res) => {
                if (res.status === 200 && res.data) {
                    let datasOptions = [];

                    datasOptions.push({
                        "value": this.loggedUser.id_person,
                        "label": this.$t("yourself") + ": " +this.loggedUser.fname
                    });

                    if (res.data.message === "no group for user") {
                        this.$store.commit("userModule/setGroups", null);
                    } else {
                        this.$store.commit("userModule/setGroups", res.data);
                        const groups = res.data;

                        groups.forEach((group) => {

                            const currentGroupUsers = this.getGroupMember(group);

                            if (currentGroupUsers) {

                                datasOptions.push({
                                    "value": group.id_group,
                                    "label": this.$t(getGroupTypeName(group.id_group_type)),
                                    "disabled": true
                                });

                                currentGroupUsers.forEach((user) => {
                                    datasOptions.push({
                                        "value": user.id,
                                        "label": this.capitalize(user.name)
                                    });
                                });
                            }

                        });

                    }

                    if (datasOptions.length > 0) {
                        this.$store.commit("globalModule/setAvailableDatas", datasOptions);
                    }
                }
            });
            this.fetchUserInfo();
        },
        getAstroData() {
            // const apikey = process.env.VUE_APP_HERE_API_KEY;
            const apiUsername = process.env.VUE_APP_API_USERNAME;
            const apiPassword = process.env.VUE_APP_API_PASSWORD;
            const url = process.env.VUE_APP_API_BASE_URL;
            axios({
                method: "POST",
                url: `${url}/get_astro`,
                auth: {
                    username: apiUsername,
                    password: apiPassword
                },
                data: JSON.stringify({
                    id_user: this.loggedUser.id_person,
                    id_person: this.user.id_person,
                })
            }).then(res => {
                this.chartData = res.data;
                this.setChartVal();
                this.isPageReady = true;
                
            }).catch(e => {
                if (e.response) {
                    throw e.response;
                }
            });
        },
        updateCategory(value) {
            this.category = value;
            this.setChartVal(); 
        },
        updateCategoryType(value) {
            this.categoryType = value;
            this.setChartVal(); 
        },
        setChartVal(){
            this.isPageReady = false;
           
            if(this.category == "whole_sign_house"){
                if(this.categoryType == "birth"){
                    this.astroData = { "data": this.chartData.whole_sign_house, "transit": false};
                }else{
                    this.astroData = { "data": this.chartData.whole_sign_house, "transit": this.chartData.date_transit};
                }
            }else{
                if(this.categoryType == "birth"){
                    this.astroData = { "data": this.chartData.placidus, "transit": false};
                }else{
                    this.astroData = { "data": this.chartData.placidus, "transit": this.chartData.date_transit_placidus};
                }
            }
            this.isPageReady = true;  
        },
        fetchUserInfo() {
            this.isPageReady = false;
            if(this.currentDataId != "") {
                const user = {
                    id: this.currentDataId
                };
                getUserInfo(user).then((res) => {
                    if (res.status === 200 && res.data) {
                        this.user =  res.data;
                        this.getAstroData();
                        this.isPageReady = true;
                    } else {
                        // Handle Error
                        let message = this.$t("a-server-error-occured-please-try-later");
                        // this.$notificationsBar.alert(message, {type: "warning"});
                        this.isPageReady = true;
                    }
                });
            }
        },
        getGroupMember(group) {
            let members = [];

            if (group && group.id_person_2) {

                const membersIdArray = group.id_person_2.split(",");
                const membersNameArray = group.name.split(",");

                for (var i = membersIdArray.length - 1; i >= 0; i--) {

                    const member = {
                        id: membersIdArray[i],
                        name: membersNameArray[i]
                    };

                    members.push(member);
                }
            }

            const sorteArray = members.sort(function(a, b) {
                var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                var nameB = b.name.toUpperCase(); // ignore upper and lowercase

                if (nameA < nameB) {
                    return -1; //nameA comes first
                }

                if (nameA > nameB) {
                    return 1; // nameB comes first
                }

                return 0;  // names must be equal
            });

            return sorteArray;
        },
    }
};
</script>
<style scoped>
.chart-container {
    display: flex;
    align-items: center;
    direction: rtl;
}
.cat-dropdown {
    margin-left: 70px;
}
.cat-dropdown-sub{
    width: 200px;
}

@media only screen and (max-width: 768px) {
    .chart-info{
        text-align: center;
    }
 .chart-container {
    display: block;
    direction: ltr;
}
.cat-dropdown-sub{
  margin: auto;
}
.cat-dropdown {
    margin-left: 0px;margin-top: 15px;
}

}


</style>